module.exports = __webpack_public_path__ + "files/cdb1b222b7bd795a21b562bcf02f2eba.png";